import sum from 'lodash/sum';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  reservationStats: {},
  reservationStat: null,
};

const slice = createSlice({
  name: 'ReservationStats',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORIES
    getreservationStatsSuccess(state, action) {
      state.isLoading = false;
      state.reservationStats = action.payload;
    },

    // GET STAT
    getreservationStatSuccess(state, action) {
      state.isLoading = false;
      state.reservationStat = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getReservationStats(levelId, venueId, startDate, endDate) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/stats/reservationStatsForVenue?levelId=${levelId}&venueId=${venueId}&startDate=${startDate}&endDate=${endDate}`,
      );
      dispatch(slice.actions.getreservationStatsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
